import React, { useState, useEffect } from 'react';
import '../styles.css';
import Header from '../Components/Header';
import TopHeader from '../Components/Header/topHeader';
import TemplatesComponent from '../Components/newtemplate';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useSelector } from "react-redux";
import { MdApproval, MdOutlineTimer } from 'react-icons/md';
import { IoCheckmarkDoneCircleOutline, IoPauseCircle, IoRocketSharp } from 'react-icons/io5';
import { RxCross2 } from 'react-icons/rx';
import api from '../../config/api';

const style = {
  width: 450,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '8px',
  padding: '20px',
};

const Templates = () => {
  const [openT, setOpenT] = useState(false);
  const [editMode, setEditMode] = useState(false); 
  const [selectedTemplate, setSelectedTemplate] = useState(null); 
  const developeruid = useSelector((state) => state.authReducer.developeruid);
  const developerrole = useSelector((state) => state.authReducer.developerrole);
  const developername = useSelector((state) => state.authReducer.developername);
  const developeremail = useSelector((state) => state.authReducer.developeremail);
  const isLang = useSelector((state) => state.authReducer.lang); // Check the current language
  console.log("Developer name:",developername,"DeveloperId:", developeruid,"Developer ROle:",developerrole,"Developer Email:",developeremail);

  const handleOpen = () => {
    setCategory('');
    setPackageType('');
    setTitle('');
    setImage(null);
    setImagePreview(null); // Reset image preview
    setJsonFile(null);
    setAmount('');
    setOpenT(true);
    setEditMode(false);
  };

  const handleEditOpen = (template) => {
    setSelectedTemplate(template);
    setCategory(template.category);
    setPackageType(template.pkgid);
    setTitle(template.title);
    setAmount(template.amount);
    setImagePreview(template.imagePath); // Set image preview for editing
    setOpenT(true);
    setEditMode(true);
  };

  const handleClose = () => {
    setOpenT(false);
    setEditMode(false);
    setSelectedTemplate(null);
  };

  const [category, setCategory] = useState('');
  const [pkgid, setPackageType] = useState('');
  const [title, setTitle] = useState('');
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null); // State for image preview
  const [jsonFile, setJsonFile] = useState(null);
  const [amount, setAmount] = useState('');
  const [uploadedBy, setUploadedBy] = useState(''); 
  const [categories, setCategories] = useState([]);
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allTemplates, setAllTemplates] = useState([]);
  const [filteredTemplates, setFilteredTemplates] = useState([]);
  const [activeFilter, setActiveFilter] = useState('pending');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [saveSnackbarOpen, setSaveSnackbarOpen] = useState(false);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
    setSaveSnackbarOpen(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
  
    if (!category || !pkgid || !title || !amount) {
      console.error('Please fill in all required fields');
      setSnackbarOpen(true);
      return;
    }
  
    try {
      setLoading(true);
      const formDataToSend = new FormData();
      formDataToSend.append('pkgid', pkgid);
      formDataToSend.append('title', title);
      formDataToSend.append('category', category);
      formDataToSend.append('amount', amount);
  
      if (editMode) {
        // Include the template ID when editing
        formDataToSend.append('id', selectedTemplate.id);
      }
      console.log("Updated data:",formDataToSend);
  
      const url = editMode
        ? api.getUrl(api.ENDPOINTS.DEV_SAVE_TEMPLATE)
        : api.getUrl(api.ENDPOINTS.DEV_UPLOAD_TEMPLATE);
  
      const response = await fetch(url, {
        method: 'POST',
        body: formDataToSend,
      });
  
      if (response.ok) {
        console.log('Template data successfully sent to the API', response.status);
        handleClose();
        fetchTemplates(); // Refresh templates after saving
        filterTemplates(activeFilter); // Reapply the active filter
      } else {
        console.error('Failed to send data to the API. Status:', response.status);
      }
      setLoading(false);
      setSaveSnackbarOpen(true);
    } catch (error) {
      console.error('Error saving template:', error.message);
      setLoading(false);
    }
  };
  

  // Fetch Templates
  const fetchTemplates = async () => {
    console.log("Api is called...")
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('id', developeruid);
      const response = await fetch(api.getUrl(api.ENDPOINTS.DEV_GET_USER_TEMPLATES), {
        method: 'POST',
        body: formDataToSend,
      });
      if (!response.ok) {
        throw new Error('Failed to fetch templates');
      }
      const data = await response.json();
      console.log("Data is :",data);
      setAllTemplates(data);
      const filtered = data.filter(template => template.status.toLowerCase() === activeFilter);
      setFilteredTemplates(filtered);
    } catch (error) {
      console.error('Error fetching templates:', error.message);
    }
  };

  // Fetch Categories
  const fetchCategories = async () => {
    try {
      const response = await fetch(api.getUrl(api.ENDPOINTS.GET_CATEGORIES));
      if (!response.ok) {
        throw new Error('Failed to fetch categories');
      }
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.error('Error fetching categories:', error.message);
    }
  };

  // Fetch Packages
  const fetchPackages = async () => {
    try {
      const response = await fetch(api.getUrl(api.ENDPOINTS.GET_PACKAGES));
      if (!response.ok) {
        throw new Error('Failed to fetch packages');
      }
      const data = await response.json();
      setPackages(data);
    } catch (error) {
      console.error('Error fetching packages:', error.message);
    }
  };

  // useEffect to fetch initial data
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem('userData'));
    if (storedData && storedData.id) {
      setUploadedBy(storedData.id); 
    }

    fetchCategories();
    fetchPackages();
    fetchTemplates();
  }, []);

  // Handle Image Change
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file)); // Show image preview
    }
  };

  // Filter Templates based on status
  const filterTemplates = (status) => {
    setActiveFilter(status);
    if (status === 'all') {
      setFilteredTemplates(allTemplates);
    } else {
      const filtered = allTemplates.filter(template => template.status.toLowerCase() === status);
      setFilteredTemplates(filtered);
    }
  };

  return (
    <>
      <div className='containers'>
        <Header />
        <div>
          <TopHeader title={isLang === 'arabic' ? "قوالب" : "Templates"} />
          <div style={{ padding: '30px 60px', textAlign:"right" }}>
            
            <div className="flex space-x-4 h-20 mt-4 text-center">
  {/* Pending Templates */}
  <div
    onClick={() => filterTemplates('pending')}
    className={`flex flex-col w-52 justify-center items-center space-y-2 px-4 py-2 rounded-lg shadow-md cursor-pointer ${
      activeFilter === 'pending'
        ? 'bg-gradient-to-r from-purple-500 to-indigo-500 text-white'
        : 'bg-gradient-to-r from-purple-300 to-indigo-300 text-white'
    }`}
  >
    <MdOutlineTimer className="text-3xl" />
    <span>{isLang === 'arabic' ? "القوالب المعلقة" : "Pending Templates"}</span>
  </div>

  {/* Approved Templates */}
  <div
    onClick={() => filterTemplates('approved')}
    className={`flex flex-col w-52 justify-center items-center space-y-2 px-4 py-2 rounded-lg shadow-md cursor-pointer ${
      activeFilter === 'approved'
        ? 'bg-green-500 text-white'
        : 'bg-green-100 text-green-600'
    }`}
  >
    <IoCheckmarkDoneCircleOutline className="text-3xl" />
    <span>{isLang === 'arabic' ? "القوالب الموافق عليها" : "Approved Templates"}</span>
  </div>

  {/* Rejected Templates */}
  <div
    onClick={() => filterTemplates('rejected')}
    className={`flex flex-col w-52 justify-center items-center space-y-2 px-4 py-2 rounded-lg shadow-md cursor-pointer ${
      activeFilter === 'rejected'
        ? 'bg-red-500 text-white'
        : 'bg-red-100 text-red-600'
    }`}
  >
    <RxCross2 className="text-3xl" />
    <span>{isLang === 'arabic' ? "القوالب المرفوضة" : "Rejected Templates"}</span>
  </div>
</div>
          
            <TemplatesComponent templates={filteredTemplates} fetchTemplates={fetchTemplates} />
          </div>
        </div>
      </div>

      {/* Snackbar for Errors */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
          {isLang === 'arabic' ? "يرجى ملء جميع الحقول المطلوبة." : "Please fill in all required fields."}
        </Alert>
      </Snackbar>

      {/* Snackbar for Success */}
      <Snackbar
        open={saveSnackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
          {isLang === 'arabic' ? "تم حفظ القوالب بنجاح!" : "Templates saved successfully!"}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Templates;
